export class QuickLinksModel {
    public id: any;
    public link_name: string;
    public link_url: string;
    public created_dt: Date;
    public created_by: string;
    public updated_dt: Date;
    public updated_by: string;
    public status: string;

    constructor() {
        this.id = "";
        this.link_name = "";
        this.link_url = "";
        this.created_dt = null;
        this.created_by = "";
        this.updated_dt = null;
        this.updated_by = "";
        this.status = "";
    }

}
